import { render, staticRenderFns } from "./msAdvanceDetails.vue?vue&type=template&id=372dbd28&scoped=true"
import script from "./msAdvanceDetails.vue?vue&type=script&lang=js"
export * from "./msAdvanceDetails.vue?vue&type=script&lang=js"
import style0 from "./msAdvanceDetails.vue?vue&type=style&index=0&id=372dbd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372dbd28",
  null
  
)

export default component.exports